import ExecutiveSetsPage from "./pages/ExecutiveSetsPage";
import ExecutiveSetDetailsPage from "./pages/ExecutiveSetDetailsPage";

/** Gated on the privilege — see the note in chapter/routes.tsx. */
export const executiveSetRoutes = [
  {
    path: "/executive-sets",
    element: <ExecutiveSetsPage />,
    perms: ["executive_set.access"],
  },
  {
    path: "/executive-sets/:id",
    element: <ExecutiveSetDetailsPage />,
    perms: ["executive_set.access"],
  },
];
